/* eslint-disable prefer-rest-params */
/* eslint-disable one-var */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable no-undef */
/* eslint-disable no-new */
/* eslint-disable func-names */
/* eslint-disable prefer-arrow-callback */
/* eslint no-unused-vars: "off" */
/* global FullCalendar */
/* eslint-disable-next-line no-undef */
/* eslint-disable */
$(document).ready(function onReady() {
    function initSliders() {
        $('.home-news-slider').slick({
            vertical: true,
            verticalSwiping: true,
            dots: false,
            arrows: true,
            speed: 300,
            slidesToShow: 3,
            infinite: true,
            adaptiveHeight: true,
            responsive: [{
                breakpoint: 1201,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    vertical: true,
                    verticalSwiping: true,
                },
            }, {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    vertical: true,
                    verticalSwiping: true,
                },
            }, {
                breakpoint: 913,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    vertical: false,
                    verticalSwiping: false,
                },
            }, {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    vertical: false,
                    verticalSwiping: false,
                },
            }],
        });
    }
    // Initial slider initialization
    initSliders();
    // Handle tab click event and refresh the sliders
    $('button[data-bs-toggle="tab"]').on('shown.bs.tab', function () {
        if ($('.home-news-slider').hasClass('slick-initialized')) {
            $('.home-news-slider').slick('unslick');
        }
        initSliders(); // reinitialize
    });
    // Trigger the first tab click to initialize
    $('#nav-store-tab').trigger('shown.bs.tab');
});
$(document).ready(function () {
    function initSlidersnews() {
        $('.home-news-content-slider').slick({
            vertical: true,
            verticalSwiping: true,
            dots: false,
            arrows: true,
            speed: 300,
            slidesToShow: 3,
            adaptiveHeight: true,
            infinite: true,
            centerMode: false,
            responsive: [{
                breakpoint: 1201,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    vertical: true,
                    verticalSwiping: true,
                },
            }, {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    vertical: true,
                    verticalSwiping: true,
                },
            }, {
                breakpoint: 913,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    vertical: false,
                    verticalSwiping: false,
                },
            }, {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    vertical: false,
                    verticalSwiping: false,
                },
            }, {
                breakpoint: 415,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    vertical: false,
                    verticalSwiping: false,
                },
            },
            ],
        });
    }
    // Initial slider initialization
    initSlidersnews();
    // Handle tab click event and refresh the sliders
    $('button[data-bs-toggle="tab"]').on('shown.bs.tab', function () {
        if ($('.home-news-content-slider').hasClass('slick-initialized')) {
            $('.home-news-content-slider').slick('unslick');
        }
        initSlidersnews(); // reinitialize
    });
    // Trigger the first tab click to initialize
    $('#nav-release-tab').trigger('shown.bs.tab');
});
$(document).ready(function () {
    function initSlider() {
        $('.latest-news-slider').slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            adaptiveHeight: true,
            responsive: [{
                breakpoint: 1201,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            }, {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            }, {
                breakpoint: 840,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            }, {
                breakpoint: 525,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            }],
        });
    }
    // Initial slider initialization
    initSlider();
    // Handle tab click event and refresh the sliders
    $('button[data-bs-toggle="tab"]').on('shown.bs.tab', function () {
        if ($('.latest-news-slider').hasClass('slick-initialized')) {
            $('.latest-news-slider').slick('unslick');
        }
        initSlider(); // reinitialize
    });
    // Trigger the first tab click to initialize
    $('#nav-home').trigger('shown.bs.tab');
});
$('.services-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 6,
    adaptiveHeight: true,
    responsive: [
        {
            breakpoint: 1201,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 840,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
    ],
});
$('.slick-track').removeAttr('role');
$('.slick-slide').attr('role', 'listitem');
$('.slick-slide').removeAttr('aria-describedby');
$('.slick-prev, .slick-next').removeAttr('role data-role');
$('.slick-prev,.slick-next')
    .attr('aria-label', function () {
        return $(this).hasClass('slick-prev')
            ? 'Go to previous slide'
            : 'Go to Next slide';
    });
$('.slick-list').attr('aria-atomic', 'true');
$('.calendar-events-row > a').attr('role', 'listitem');
$(document).ready(function OnReady() {
    // Show the left arrow when the slider is interacted with
    $('.slick-slider-section').on('afterChange', function onChange(event, slick, currentSlides) {
        if (currentSlides > 0) {
            $('.slick-slider-section .slick-arrow').addClass('active-color');
        }
        else {
            $('.slick-slider-section .slick-arrow').removeClass('active-color');
        }
    });
    // Ensure left arrow shows up on the first interaction
    $('.slick-slider-section .slick-next').one('click', function handleSlickNextClick() {
        $('.slick-slider-section .slick-arrow').addClass('active-color');
    });
});
$(document).ready(() => {
    $('#main-div .news-article-page table').each(function () {
        $(this).addClass('table table-bordered');
        $(this).wrap('<div class="table-responsive"></div>');
    });
    $('.calendar-event-date').each(function assignEvenOddClasses(index) {
        if ((index + 1) % 2 === 0) {
            $(this).addClass('even');
        }
        else {
            $(this).addClass('odd');
        }
    });
});
$(document).ready(function OnReady() {
    $('.container1').click(() => {
        $('body').addClass('body');
        $('.navbar-collapse ul.navbar-nav li').removeClass('active');
    });
    $('.navbar-collapse ul.navbar-nav li').on('click', function OnClick() {
        $(this).addClass('active').siblings().removeClass('active');
    });
    $('.navbar-collapse ul.navbar-nav li.navbar-menu-item').on('click', function OnClick() {
        $('body').addClass('body');
        $('body').addClass('menu-items-active');
    });
    if ($(window).width() > 991) {
        $('.navbar-collapse ul.navbar-nav li.site-login').on('click', () => {
            $('body').removeClass('body');
            $('body').removeClass('menu-items-active');
        });
    }
    $('.close-btn').on('click', () => {
        $('.navbar-collapse ul.navbar-nav li').removeClass('active');
        $('body').removeClass('body');
        $('.navbar-collapse').removeClass('active');
        $('body').removeClass('menu-items-active');
    });
    $('.back-btn').on('click', function OnClick() {
        $('.navbar-collapse ul.navbar-nav li').removeClass('active');
        $('body').removeClass('menu-items-active');
    });
});
$(document).ready(() => {
    $('.tab-section .tab-links a').on('click', function handelTab(e) {
        e.preventDefault();
        const currentAttrValue = $(this).attr('data-bs-target');
        $('.tab-section .tab-pane').removeClass('active show');
        $(currentAttrValue).addClass('active show');
        $(this).parent('li').addClass('active').siblings()
            .removeClass('active');
    });
});
$(document).ready(function OnReady() {
    $('.frequently-questions .accordion-header').click(function OnClick() {
        const content = $(this).next('.accordion-content');
        content.slideToggle(300);
        $('.frequently-questions .accordion-content').not(content).slideUp(300);
        $(this).parent('.accordion-item').toggleClass('active');
        $(this).parent('.accordion-item').siblings().removeClass('active');
    });
});
$(document).ready(function OnReady() {
    $('.staff-modal-wrapper').on('click', function OnClick(event) {
        if (!$(event.target).closest('.modal-content, .next, .prev').length) {
            $('.staff-modal-wrapper').hide();
            $('body').removeClass('body staff-modal-open');
        }
    });
    $('.next, .prev').on('click', (event) => {
        event.stopPropagation();
    });
});
// Function to initialize a calendar
function initializeCalendar(calendarId) {
    const calendarEl = document.getElementById(calendarId);
    if (calendarEl) {
        const calendar = new FullCalendar.Calendar(calendarEl, {
            initialView: 'dayGridMonth',
            selectable: false,
            contentHeight: 'auto',
            headerToolbar: {
                center: '',
                left: '',
                right: '',
            },
        });
        calendar.render();
        return calendar;
    }
    return null;
}
// Store calendar instances
const calendars = {
    'nav-home': initializeCalendar('calendar'),
    'nav-council': initializeCalendar('calendarone'),
    'nav-profile': initializeCalendar('calendartwo'),
};
// Function to handle tab switching
function handleTabSwitch(tabId) {
    if (calendars[tabId]) {
        // Ensure the calendar renders properly when its tab is shown
        calendars[tabId].render();
    }
}
// Add event listener for tab switch
document.querySelectorAll('button[data-bs-toggle="tab"]').forEach(function HandelTab(tab) {
    tab.addEventListener('shown.bs.tab', (event) => {
        const target = event.target.getAttribute('data-bs-target').substring(1); // Get the target tab id
        handleTabSwitch(target);
    });
});
/* Staff Modal Start */
function openModal(modelId) {
    document.getElementById(modelId).style.display = 'block';
    $('body').addClass('staff-modal-open');
    $("body").addClass("body");
}
function closeModal(modelId) {
    document.getElementById(modelId).style.display = 'none';
    $('body').removeClass('staff-modal-open');
    $("body").removeClass("body");
}
let slideIndex = 1;
function showSlides(ModelId, n) {
    let i;
    const slides = $('#' + ModelId + ' .mySlides');
    const dots = $('#' + ModelId + ' .demo');
    const captionText = $('#' + ModelId + ' #caption');

    if (slides.length == 1 || slides.length == 0) {
        $(".mySlides-arrow").hide();
    } else {
        $(".mySlides-arrow").show();
    }
    if (n > slides.length) {
        slideIndex = 1;
    }
    if (n < 1) {
        slideIndex = slides.length;
    }
    for (i = 0; i < slides.length; i++) {
        slides[i].style.display = 'none';
    }
    for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(' active', '');
    }
    if (slides.length > 0) {
        slides[slideIndex - 1].style.display = 'block';
    }
    if (dots.length > 0) {
        dots[slideIndex - 1].className += ' active';
    }
    if (captionText != null && dots.length > 0) {
        captionText.innerHTML = dots[slideIndex - 1].alt;
    }
}
function plusSlides(ModelId, n) {
    showSlides(ModelId, (slideIndex += n));
}
function currentSlide(ModelId, n) {
    showSlides(ModelId, (slideIndex = n));
}
/* Autocomplete seach JS */
function SearchResult() {
    const searchStr = $('.searchbox').val();
    const searchUrl = host + 'SearchRecommendations?Terms=' + searchStr;
    $('#myInputautocomplete-list').remove();
    if (searchStr !== '' && searchStr.length > 2) {
        $("<div id='myInputautocomplete-list' class='autocomplete-items' ></div>").insertAfter('.searchbox');
        $('#myInputautocomplete-list')
            .append('<div id="divResultLoader" style="text-align:center;">' +
                '<img style="height: 3rem;" alt="indicator" src = "GovBuilt.Theme.MissouriWave/images/indicator.gif"></div> ');
        $.ajax({
            url: searchUrl,
            async: true,
            method: 'GET',
            success: function (data) {
                $('#divResultLoader').hide();
                if (data !== undefined && data != null && data.statusCode !== undefined &&
                    data.statusCode != null && data.statusCode === 200 && data.searchResult.length > 0) {
                    $.each(data.searchResult, function () {
                        let htmlResult = '';
                        htmlResult += '<div>';
                        htmlResult += '<a href="' + this.url + '">' + this.title + '</a>';
                        if (this.summary !== undefined && this.summary != null && this.summary !== '') {
                            htmlResult += '<br/><span class="hint">' + this.summary + '</span>';
                        }
                        htmlResult += '</div>';
                        $('#myInputautocomplete-list').append(htmlResult);
                    });
                    const urlResult = host + 'Search?Terms=' + searchStr + '*';
                    $('#myInputautocomplete-list')
                        .append('<div style="text-align:center;padding:10px 0;position:sticky;bottom:0;border-top:1px solid #d4d4d4;">' +
                            '<a class= "searchResultMoreBtn" href = "' + urlResult + '">View More Results</a></div>');
                }
                else {
                    $('#myInputautocomplete-list').append('<div><span class="hint">No result found</span></div>');
                }
            },
            error: function (error) { },
        });
    }
}
function delay(callback, ms) {
    let timer = 0;
    return function () {
        const context = this,
            args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
}
$(document).ready(function () {
    $('.searchbox').keyup(
        delay(function (e) {
            SearchResult();
        }, 800)
    );
});
$(document).ready(function () {
    function toggleRemoveButton() {
        if ($('.searchbox').val() !== undefined && $('.searchbox').val().length > 0) {
            $('.remove-input-content').show();
        }
        else {
            $('.remove-input-content').hide();
        }
    }
    toggleRemoveButton();
    $('.searchbox').on('input', function () {
        toggleRemoveButton();
    });
    $('.remove-input-content').on('click', function () {
        $('.searchbox').val('');
        $(this).hide();
        $('.autocomplete-items').remove();
    });
});
$(document).ready(function () {
    $('.navbar').addClass('alertNavbar');
    $('.alertbar-close-wrapper').click(function () {
        $('.alertbar-wrapper').remove();
    });
});
$(document).ready(function () {
    $("h2").filter(function () {
        return $(this).text().trim().toLowerCase() === "forgot password?" ||
            $(this).text().trim().toLowerCase() === "register a new account";
    }).addClass("section-heading text-capitalize page-heading text-start");
    $('.profileRow').closest('#main-div').addClass('profileRow');
    $('.advancedformFEClass').closest('#main-div').addClass('advancedformFEClass');
    $('.interior-about-content table, .interior-about-content .table').each(function () {
        $(this).wrap('<div class="table-responsive"></div>');
    });
    $('.interior-about-content p').filter(function () {
        return $(this).children().length === 0 && $(this).text().trim() === ''; // Remove empty paragraphs with no child elements
    }).remove();
    $('.calendar-section p').filter(function () {
        return $(this).children().length === 0 && $(this).text().trim() === ''; // Remove empty paragraphs with no child elements
    }).remove();
    $('.newsFEClass').parent('#main-div').addClass('news-container');
    $('.advancedformFEClass').parent('#main-div').addClass('advancedform-container');
    $(".col-md-12.shape_render").parents("#main-div").addClass("news-wrapper");
    $('.navbar').prev('.widget-container').find('.widget-liquid-widget').addClass('p-0');
    $('.footer-section').closest('.widget-liquid-widget').addClass('p-0');
    $('a[href^="http"]').attr("target", "_blank");
    var $menu = $('.navbar-main-menu');
    $menu.on('keydown', function (e) {
        if ($('body').hasClass('body')) {
            if (e.key === 'Tab') {
                var $focusable = $menu.find('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])')
                    .filter(':visible');
                var first = $focusable.first()[0];
                var last = $focusable.last()[0];

                if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                } else if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                }
            }
        }
    });
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $('body').hasClass('body')) {
            $('.close-btn').trigger('click');
        }
    });
});
/* eslint-enable */
